import * as actionTypes from '../actions/actionTypes';

const initialState = {
    total: 0,
    data: [],
    keyword: false,
    sortColumn: '-',
    sortMode: '-',
    page: 1, // for now, filter and page are supported for groups only
    filter: 0,
}

const reducer = (state = initialState, action) => {
    if (action.type === actionTypes.IFC_LOOKUP_LIST_SET) {
        console.log('[action/ifcLookupList] reducer', state, action);
    }
    switch (action.type) {
        case actionTypes.IFC_LOOKUP_LIST_SET_PAGE:
            return {
                ...state,
                page: action.page
            }
        case actionTypes.IFC_LOOKUP_LIST_SET_SORT:
            return {
                ...state,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.IFC_LOOKUP_LIST_SET_KEYWORD:
            return {
                ...state,
                keyword: action.keyword,
                status: action.status
            };
        case actionTypes.IFC_LOOKUP_LIST_SET:
            return {
                ...state,
                // page: 1,
                totalPages: null,
                ...action
            };
        default:
            return state;
    }
}

export default reducer;